import { render, staticRenderFns } from "./PageVideoResource.vue?vue&type=template&id=98152070&scoped=true"
import script from "./PageVideoResource.vue?vue&type=script&lang=js"
export * from "./PageVideoResource.vue?vue&type=script&lang=js"
import style0 from "./PageVideoResource.vue?vue&type=style&index=0&id=98152070&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98152070",
  null
  
)

export default component.exports